// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"240":"66cbcc56","315":"49ffb90b","339":"bf668f2f","371":"5dd0bc05","532":"3d2a87f5","549":"cc6209c2","676":"634db19f","841":"905b9227"}[chunkId] + ".chunk.js";
};